import { useQuery, useQueryClient } from "react-query";
import { supabase } from "../../../config/supabaseClient";

export function useLoadPostIdsData(
  username: any,
  user_id: any,
  postIds: any[] = [],
  platform?: any,
  isChange?: boolean
) {
  const queryClient = useQueryClient();

  const getPostIdsFeed = async () => {
    let finalData: any = [];
    const { data: postIdData = [], error: postIdError }: any = await supabase
      .from(username)
      .select("*")
      .in("post_id", postIds)
      .ilike("index", "%active%");

    finalData=[...postIdData]


    // Sort posts based on platform and index
    const sortedPostData = postIds.map((postId) => {
      const post = finalData.find((data: any) => data.post_id.toString() === postId);
      if (post) {
        // Check if the platform is featured
        if (platform === "featured") {
          // For featured platform, only include posts with index "active,featured"
          if (post.index === "active,featured") {
            return post;
          }
          return null;
        }
        // For non-featured platforms, include all active posts
        return post;
      }
      return null;
    }).filter(Boolean); // Remove null values

    if (postIdError) {
      throw new Error(postIdError.message);
    }

    return sortedPostData;
  };

  const { data, error, isLoading } = useQuery(
    ["postIdsFeed", user_id, ...postIds],
    getPostIdsFeed,
    {
      enabled: Boolean(postIds && postIds.length >= 0),
      keepPreviousData: true,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
    }
  );

  return {
    data,
    error,
    isLoading,
    refetch: () =>
      queryClient.invalidateQueries(["postIdsFeed", user_id, ...postIds,isChange]),
  };
}
